import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { LuCalendarDays } from 'react-icons/lu';
import { MdOutlineHistory, MdOutlineClose } from "react-icons/md";
import { FaMagnifyingGlass } from "react-icons/fa6";

import "./App.css";

const RequestHistoryMenu = ({ onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deletingTitle, setDeletingTitle] = useState(null);
  const menuRef = useRef(null);
  const [history, setHistory] = useState(() => {
    const storedHistory = localStorage.getItem("requestHistory");
    return storedHistory ? JSON.parse(storedHistory) : [];
  });

  // Fetch the records on component mount
  useEffect(() => {
    const fetchRecords = async () => {
      try {
        // Fetch the records from the server
        const response = await axios.get("https://appsdashboard.cc/api/get_requests.php");
        const records = response.data.records;

        // Save the fetched records to localStorage
        localStorage.setItem("requestHistory", JSON.stringify(records));

        // Update the history state
        setHistory(records);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    fetchRecords();
  }, []); // Empty dependency array to only run this effect once on component mount



  const handleSelect = (entry) => {
    setIsOpen(false);
    onSelect(entry.params); // Pass the selected params to parent
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false); // Close the menu
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleDelete = async (title) => {
    setDeletingTitle(title);
    // Create the payload for the delete API
    const jsonPayload = {
      title: title,  // The title to delete
    };

    // Send a DELETE request to the server
    try {
      const response = await axios.post("https://appsdashboard.cc/api/delete_request.php", jsonPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Response:", response.data);
      const updatedHistory = history.filter(item => item.title !== title);
      localStorage.setItem("requestHistory", JSON.stringify(updatedHistory));
      setHistory(updatedHistory);
      setDeletingTitle(null);
    } catch (error) {
      console.error("Error deleting record:", error);
      setDeletingTitle(null);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button className="history-button" onClick={() => {
        const updHistory = JSON.parse(localStorage.getItem("requestHistory")) || [];
        setHistory(updHistory);
        setIsOpen(!isOpen)
      }}>
        <MdOutlineHistory size={24} style={{ opacity: '0.5' }} />
      </button>
      {isOpen && (
        <div
          ref={menuRef}
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            background: "white",
            border: "1px solid #ccc",
            width: "730px",
            borderRadius: "5px",
            zIndex: 1000,
          }}
        >
          {history.length === 0 ? (
            <div style={{ padding: "10px", textAlign: "center" }}>No history</div>
          ) : (
            history.map((entry, index) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  key={index}
                  style={{
                    padding: "10px",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    width: "700px",
                  }}
                  onClick={() => handleSelect(entry)}
                >

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ opacity: deletingTitle === entry.title ? '0.5' : '1.0', fontSize: "12px", fontWeight: "bold" }}>{entry.title}</span>
                    <span style={{ opacity: deletingTitle === entry.title ? '0.5' : '1.0', fontSize: "12px", fontWeight: "bold" }}>{new Date(entry.timestamp).toLocaleString()}</span>
                  </div>
                  {/* {date, history_days_start, history_days_end, history_rank_start, history_rank_end, released, page, depth, sort, types} */}
                  <span style={{ opacity: deletingTitle === entry.title ? '0.5' : '1.0', fontSize: "12px" }}>Date: {entry.params.date}, Released: {entry.params.released}, Sort: {entry.params.sort},
                    Top 500 limits: {entry.params.history_rank_start}-{entry.params.history_rank_end}, Days: {entry.params.history_days_start}-{entry.params.history_days_end},
                    Depth: {entry.params.depth}, Types: {!entry.params.types ? "free, grossing" : entry.params.types}
                  </span>
                </div>

                <button className="delete-button" onClick={() => handleDelete(entry.title)}>
                  <MdOutlineClose size={20} style={{
                    opacity: deletingTitle === entry.title ? '0.5' : '0.9',
                    color: deletingTitle === entry.title ? 'gray' : 'red',
                    transform: deletingTitle === entry.title ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'transform 0.5s ease, color 0.3s ease',
                  }} />
                </button>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

const DateButton = ({ date, setDate, id }) => {
  const inputRef = React.useRef(null);
  const [inputValue, setInputValue] = useState('');
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isChrome = /Chrome/.test(navigator.userAgent);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // const parseDate = (inputString) => {
  //   if (!inputString) return null;
  //   const date = new Date(inputString);
  //   if (isNaN(date.getTime())) return null;
  //   return new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
  //     .toISOString()
  //     .split('T')[0];
  // };

  useEffect(() => {
    setInputValue(formatDate(date));
  }, [date]);

  const handlePickerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!inputRef.current) return;

    if (isChrome) {
      inputRef.current.focus();
      try {
        inputRef.current.showPicker();
      } catch (err) {
        console.log('showPicker failed:', err);
      }
    } else if (isSafari) {
      inputRef.current.focus();
    }
  };

  const handlePickerChange = (e) => {
    const newDate = e.target.value;
    setDate(newDate);
    setInputValue(formatDate(newDate));

    if (isSafari) {
      inputRef.current?.blur();
      // Add a small delay before focusing on body to ensure proper dismissal
      setTimeout(() => {
        document.body.click();
      }, 100);
    }
  };

  const isValidDateFormat = (str) => {
    // Matches format like "Dec 12, 2024"
    const regex = /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s([1-9]|[12][0-9]|3[01]),\s\d{4}$/;
    if (!regex.test(str)) return false;

    // Additional validation for valid date
    const date = new Date(str);
    if (isNaN(date.getTime())) return false;

    // Verify that the date actually matches the input
    // This catches cases like "Feb 31, 2024"
    const formattedBack = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    return formattedBack === str;
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputBlur = () => {
    if (!inputValue) {
      setInputValue(formatDate(date));
      return;
    }

    if (isValidDateFormat(inputValue)) {
      const newDate = new Date(inputValue);
      const formattedDate = new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000))
        .toISOString()
        .split('T')[0];
      setDate(formattedDate);
    } else {
      // Reset to the last valid date if input is invalid
      setInputValue(formatDate(date));
    }
  };

  return (
    <div style={{ position: 'relative', width: 'fit-content' }}>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        style={{
          padding: '6px 11px',
          paddingRight: '35px',
          fontSize: '14px',
          borderRadius: '6px',
          border: '1px solid rgba(120, 120, 128, 0.2)',
          width: '90px',
          outline: 'none',
        }}
        placeholder="Dec 12, 2024"
      />

      <div style={{
        position: 'absolute',
        right: 0,
        top: 0,
        height: '100%',
        width: '20px',
        marginRight: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <LuCalendarDays
          size={16}
          style={{
            color: '#007AFF',
            cursor: 'pointer',
            position: 'relative',
            zIndex: isSafari ? 1 : 2,  // Lower z-index in Safari
            pointerEvents: isSafari ? 'none' : 'auto', // Disable pointer events in Safari
          }}
          onClick={handlePickerClick}
        />
        <input
          ref={inputRef}
          id={id}
          type="date"
          value={date || ''}
          onChange={handlePickerChange}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            zIndex: isSafari ? 2 : 1, // Higher z-index in Safari
            cursor: 'pointer',
            ...(isSafari ? {
              '-webkit-appearance': 'none',
              display: 'block',
            } : {})
          }}
        />
      </div>
    </div>
  );
};



// <LuCalendarDays size={14} color="#007aff" />


const SortButtons = ({ sort, setSort }) => {
  // Local state to track direction for each button
  const [buttonDirections, setButtonDirections] = useState({
    gain: 'desc',
    rank: 'desc',
    release: 'desc',
  });

  const handleSortChange = (field) => {
    // Determine the current direction for the field
    const currentDirection = sort.includes(`${field}_asc`) ? 'asc' : 'desc';
    const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';

    // Update the sort state with the field and the new direction
    setSort(`${field}_${newDirection}`);

    // Update the direction for the selected button in buttonDirections
    setButtonDirections((prevState) => ({
      ...prevState,
      [field]: newDirection,
    }));
  };



  return (
    <div className="sort-buttons">
      {[
        { label: 'Gain', value: 'gain' },
        { label: 'Rank', value: 'rank' },
        { label: 'Release Date', value: 'release' },
      ].map((button) => {
        const isActive = sort.startsWith(button.value);
        const direction = isActive
          ? sort.includes('asc')
            ? 'asc'
            : 'desc'
          : buttonDirections[button.value]; // Use stored direction for inactive buttons

        return (
          <button
            key={button.value}
            style={{
              color: isActive ? '#007aff' : '#525252', // Change color for active button
              display: 'inline-flex', // Use flexbox for vertical alignment
              alignItems: 'center', // Vertically center content
              padding: '6px 11px', // Add padding for better spacing
              fontSize: '14px',
            }}
            onClick={() => handleSortChange(button.value)} // Handle sort change on click
          >
            {button.label}
            {/* Show the arrow for all buttons */}
            <span
              className="arrow"
              style={{
                fontWeight: '200', // Lighter weight for the arrow
                fontSize: '8px', // Adjust size for a better fit
                marginLeft: '5px', // Space between text and arrow
                color: isActive ? '#007aff' : '#525252',
                fontFamily: '"Arial", sans-serif',
                display: 'inline-flex', // Use inline-flex for the arrow
                alignItems: 'center', // Vertically align the arrow with the text
                transform: 'scaleY(1.5)',
              }}
            >
              {/* Display the arrow based on the current direction */}
              {isActive ? (direction === 'asc' ? <FaArrowUp /> : <FaArrowDown />) : direction === 'asc' ? <FaArrowUp /> : <FaArrowDown />}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const DataTable = ({ data, isLoading }) => {
  return (
    <div className="table-container">
      <div className={`loading-overlay ${isLoading ? 'visible' : ''}`}>
        <div className="loading-spinner"></div>
      </div>

      {!data || !data.output ? (
        <div className="placeholder" style={{ opacity: isLoading ? '0.3' : '1.0' }}>

          <span>{isLoading ? "" : `Click "Update" to load the data`}</span>

        </div>
      ) : (


        data.output.length === 0 ? (
          <div className="placeholder" style={{ opacity: isLoading ? '0.3' : '1.0' }}>
            <span>No results were found</span>
          </div>
        )
          : (
            <table className="data-table" style={{ opacity: isLoading ? '0.3' : '1.0' }}>
              <colgroup>
                <col style={{ minWidth: data.page > 9 ? '50px' : '40px', width: data.page > 9 ? '50px' : '40px' }} />
                <col style={{ minWidth: '50px', width: '50px' }} />
                <col style={{ minWidth: '50px', width: '50px' }} />
                <col style={{ minWidth: '100px', width: '100px' }} />
                <col style={{ minWidth: '100px', width: '100px' }} />
                <col style={{ minWidth: '40px', width: '40px' }} />
                <col style={{ minWidth: '300px', width: '300px' }} />
                <col style={{ width: 'auto' }} />
              </colgroup>
              <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
                <tr className="header-row">
                  <th>#</th>
                  <th>Rank</th>
                  <th>Gain</th>
                  <th>Released</th>
                  <th>Rating</th>
                  <th><FaMagnifyingGlass size={16} /></th>
                  <th>Screenshots</th>
                  <th>Content</th>
                </tr>
              </thead>
              <tbody>
                {data.output.map((item, index) => {
                  const appData = Object.values(item)[0];
                  return (
                    <tr key={appData.app_id} className="data-row">
                      <td>{data.page === 1 ? index + 1 : (data.page - 1) * data.output.length + index + 1}</td>
                      <td>{appData.rank}</td>
                      <td style={{ color: appData.gain >= 0 ? "#09cc2a" : "red" }}>
                        {appData.gain >= 0 ? `+${appData.gain}` : `${appData.gain}`}
                      </td>

                      <td>{new Date(appData.releaseDate).toISOString().split('T')[0]}</td>
                      <td style={{ textAlign: "center", verticalAlign: "top" }}>
                        {appData.rating.toFixed(2)}
                        <br />
                        <span>({appData.ratingCount})</span>
                      </td>
                      <td>{appData.history_filter}</td>

                      <td className="screenshot-cell">
                        <div className="screenshot-wrapper">
                          {appData.screenshot.slice(0, 3).map((url, i) => (
                            <img
                              key={i}
                              src={url}
                              alt={`Screenshot ${i + 1}`}
                              className="screenshot"
                            />
                          ))}
                          {appData.screenshot.length === 0 && (
                            <span className="no-screenshots">No screenshots</span>
                          )}
                        </div>
                      </td>
                      <td className="content-cell">


                        <div className="text-content">
                          <div className="content-wrapper">
                            <img src={appData.icon} alt="App Icon" className="icon" />
                            <strong>
                              <a
                                href={`https://apps.apple.com/us/app/${appData.app_id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'underline', color: 'inherit' }}
                              >
                                {appData.name}
                              </a> - {appData.category} ({appData.type})
                            </strong>
                          </div>
                          <p className="description">
                            {appData.description.replace(/\u00A0/g, ' ').slice(0, 1000)}{appData.description.length > 1000 && '...'}
                          </p>

                        </div>

                      </td>

                    </tr>
                  );
                })}
              </tbody>
            </table>
          )
      )}
    </div>
  );
};


const App = () => {
  // const correctPassword = "your-password"; // Set the default password here.
  // const [isAuthenticated, setIsAuthenticated] = useState(false);

  // State hooks for the rest of the app
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [released, setReleased] = useState("2000-01-01");
  const [historyDaysStart, setHistoryDaysStart] = useState(0);
  const [historyDaysEnd, setHistoryDaysEnd] = useState(365);
  const [depth, setDepth] = useState(365);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(null);
  const [historyRankStart, setHistoryRankStart] = useState(0);
  const [historyRankEnd, setHistoryRankEnd] = useState(500);
  const [types, setTypes] = useState({ free: true, grossing: true });
  const [sort, setSort] = useState("gain_desc");
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [tempValue, setTempValue] = useState(1);
  const [title, setTitle] = useState('');
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [saveButtonText, setSaveButtonText] = useState('Save');
  const [isSaving, setIsSaving] = useState(false);
  const dialogRef = useRef(null);

  useEffect(() => {
    const updateRangeProgress = (input) => {
      const value = Number(input.value);
      const min = Number(input.min);
      const max = Number(input.max);

      // If min equals max (when sliders meet), show 0% progress (all gray)
      const progress = min === max ? 0 : ((value - min) / (max - min)) * 100;
      input.style.setProperty('--range-progress', `${progress}%`);
    };

    const rangeInputs = document.querySelectorAll('input[type="range"]');
    rangeInputs.forEach(input => {
      updateRangeProgress(input);
      input.addEventListener('input', (e) => updateRangeProgress(e.target));
    });

    // Update all sliders when dependencies change
    rangeInputs.forEach(input => updateRangeProgress(input));

    return () => {
      rangeInputs.forEach(input => {
        input.removeEventListener('input', (e) => updateRangeProgress(e.target));
      });
    };
  }, [historyRankStart, historyRankEnd, historyDaysStart, historyDaysEnd]);

  // Event handlers
  const handleTypesChange = (type) => {
    setTypes((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const goUp = () => {
    window.scrollTo(0, 0);
  }

  const saveRequestToHistory = async () => {

    const params = {
      date,
      history_days_start: historyDaysStart,
      history_days_end: historyDaysEnd,
      history_rank_start: historyRankStart,
      history_rank_end: historyRankEnd,
      released,
      page: 1,
      depth: depth,
      sort,
    };

    if (!(types.free && types.grossing)) {
      params.types = Object.keys(types).filter((type) => types[type]).join(",");
    }

    const jsonPayload = {
      title: title || 'New search',
      params,
      timestamp: new Date().toISOString(),
    };

    try {
      const response = await axios.post("https://appsdashboard.cc/api/save_request.php", jsonPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Record saved successfully:", response.data);
      return { success: true };
    } catch (error) {
      console.error("Error saving record:", error);
      return { success: false };
    }
  };

  const handleUpdate = async (currentPage) => {
    window.scrollTo(0, 0);
    setIsLoading(true);

    setResponse(null);

    if (!Number.isInteger(currentPage)) {
      currentPage = 1
    }
    console.log("currentPage1:", currentPage);

    const params = {
      date,
      history_days_start: historyDaysStart,
      history_days_end: historyDaysEnd,
      history_rank_start: historyRankStart,
      history_rank_end: historyRankEnd,
      released,
      page: currentPage,
      depth: depth,
      sort,
    };

    if (!(types.free && types.grossing)) {
      params.types = Object.keys(types).filter((type) => types[type]).join(",");
    }


    // const url = new URL("https://nftai.pro/apptweak/api/filter.php");
    // Object.keys(params).forEach((key) =>
    //   url.searchParams.append(key, params[key])
    // );
    // console.log("Full URL:", url.toString());

    try {
      const response = await axios.get("https://nftai.pro/apptweak/api/filter.php", { params });
      // const response = await axios.get("/apptweak/api/filter.php", { params });
      console.log("Response:", response.data);
      setResponse(response.data)
      setPages(response.data.pages)
      setPage(response.data.page)

      if (response.data.output.length === 0) {
        setPages(null)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    setSaveButtonText('Saving...');

    const response = await saveRequestToHistory();

    if (response.success) {
      setSaveButtonText('Saved!');
      setTimeout(() => {
        setIsDialogOpen(false);
        setSaveButtonText('Save');
        setIsSaving(false);
        setTitle('');
      }, 1000);
    } else {
      setSaveButtonText('Failed');
      setTimeout(() => {
        setIsDialogOpen(false);
        setSaveButtonText('Save');
        setIsSaving(false);
        setTitle('');
      }, 1000);
    }

    try {
      const response = await axios.get("https://appsdashboard.cc/api/get_requests.php");
      const records = response.data.records;

      // console.log("All Records:", records);

      // Save to local storage

      localStorage.setItem("requestHistory", JSON.stringify(records));

      // console.log("History from Local Storage:", history);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
    setTitle('')
  };

  const onPrevious = async () => {
    const newPage = page === 1 ? 1 : page - 1;
    setPage(newPage);
    handleUpdate(newPage);
  };

  const onNext = async () => {
    const newPage = page === pages ? page : page + 1;
    setPage(newPage);
    handleUpdate(newPage);
  };

  useEffect(() => {
    setTempValue(page);
  }, [page]);

  // Handle when user finishes editing (either blur or enter key)
  const handleBlurOrEnter = () => {
    // Call handleUpdate when the input field loses focus or user presses Enter
    setPage(tempValue)
    handleUpdate(tempValue);
  };

  useEffect(() => {
    if (isDialogOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDialogOpen]);

  const handleClickOutside = (event) => {
    if (dialogRef.current && !dialogRef.current.contains(event.target)) {
      setIsDialogOpen(false);
      setTitle('')
    }
  };

  const handleUpdateHistory = async (hDate, hReleased, hDaysStart, hDaysEnd, hDepth, hRankStart, hRankEnd, hSort, hTypes) => {
    window.scrollTo(0, 0);
    setIsLoading(true);

    const params = {
      date: hDate,
      history_days_start: hDaysStart,
      history_days_end: hDaysEnd,
      history_rank_start: hRankStart,
      history_rank_end: hRankEnd,
      released: hReleased,
      page: 1,
      depth: hDepth,
      sort: hSort,
    };

    if (!(hTypes.free && hTypes.grossing)) {
      params.types = Object.keys(hTypes).filter((type) => hTypes[type]).join(",");
    }

    try {
      const response = await axios.get("https://nftai.pro/apptweak/api/filter.php", { params });
      // const response = await axios.get("/apptweak/api/filter.php", {params});
      console.log("Response:", response.data);
      setResponse(response.data)
      setPages(response.data.pages)
      setPage(response.data.page)

      if (response.data.output.length === 0) {
        setPages(null)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = Number(e.target.value);
    setDepth(value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>


      {/* Date Picker */}
      <div className='top'>
        <div className='top-date'>
          <p style={{ fontSize: '16px', fontWeight: 'bold' }}>Date</p>
          <DateButton date={date} setDate={setDate} id="date-picker-1" />
        </div>
        <RequestHistoryMenu
          onSelect={(params) => {
            setDate(params.date);
            setReleased(params.released);
            setHistoryDaysStart(params.history_days_start);
            setHistoryDaysEnd(params.history_days_end);
            setDepth(params.depth);
            setHistoryRankStart(params.history_rank_start);
            setHistoryRankEnd(params.history_rank_end);
            setSort(params.sort);

            setTypes(
              params.types
                ? {
                  free: params.types.includes("free"),
                  grossing: params.types.includes("grossing"),
                }
                : { free: true, grossing: true }
            );
            handleUpdateHistory(params.date, params.released, params.history_days_start, params.history_days_end, params.depth, params.history_rank_start, params.history_rank_end, params.sort, params.types
              ? {
                free: params.types.includes("free"),
                grossing: params.types.includes("grossing"),
              }
              : { free: true, grossing: true });
          }}
        />

      </div>
      <div className='gray-area'>

        <p style={{ fontSize: '16px', fontWeight: 'bold', paddingLeft: '10px', lineHeight: '1', margin: '0px' }}>Filter</p>

        <div className='released-part'>
          <p>Released from</p>
          <DateButton date={released} setDate={setReleased} id="date-picker-2" />

          <p style={{ paddingLeft: '10px' }}>Sort by</p>

          {/* Sort Buttons */}
          <div className="sort-buttons">
            <SortButtons sort={sort} setSort={setSort} />
          </div>

        </div>

        <hr />

        {/* Sliders */}
        <div className="slider-container">

          <span>TOP 500 Rank limits:</span>
          <div className="slider-wrapper">
            <span style={{ marginRight: '20px' }}>Upper limit: </span>
            <div className="underline">
              <span className="slider-min">0</span>
              <input
                type="range"
                min="0"
                max="500"
                value={historyRankStart}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setHistoryRankStart(value);
                  if (value > historyRankEnd) setHistoryRankEnd(value);
                }}
                style={{
                  "--range-progress": `${(historyRankStart / 500) * 100}%`,
                }}
              />
              <span className="slider-max">{historyRankEnd}</span>
            </div>
          </div>
          <div className="slider-wrapper">
            <span style={{ marginRight: '20px' }}>Bottom limit: </span>
            <div className="underline">
              <span className="slider-min">{historyRankStart}</span>
              <input
                type="range"
                min={historyRankStart}
                max="500"
                value={historyRankEnd}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setHistoryRankEnd(value);
                  if (value < historyRankStart) setHistoryRankStart(value);
                }}
                style={{
                  "--range-progress": `${(historyRankEnd / 500) * 100}%`,
                }}
              />
              <span className="slider-max">500</span>
            </div>
          </div>
        </div>
        <hr />
        <div className="slider-container">
          <span>Days in requested range:</span>
          <div className="slider-wrapper">
            <span style={{ marginRight: '20px' }}>Min: </span>
            <div className="underline">
              <span className="slider-min">0</span>
              <input
                type="range"
                min="0"
                max="365"
                value={historyDaysStart}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setHistoryDaysStart(value);
                  if (value > historyDaysEnd) setHistoryDaysEnd(value);
                }}
                style={{
                  "--range-progress": `${(historyDaysStart / 365) * 100}%`,
                }}
              />
              <span className="slider-max">{historyDaysEnd}</span>
            </div>
          </div>
          <div className="slider-wrapper">
            <span style={{ marginRight: '20px' }}>Max: </span>
            <div className="underline">
              <span className="slider-min">{historyDaysStart}</span>
              <input
                type="range"
                min={historyDaysStart}
                max="365"
                value={historyDaysEnd}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  setHistoryDaysEnd(value);
                  if (value < historyDaysStart) setHistoryDaysStart(value);
                }}
                style={{
                  "--range-progress": `${(historyDaysEnd / 365) * 100}%`,
                }}
              />
              <span className="slider-max">365</span>
            </div>
          </div>

        </div>
        <hr />
        <div className='released-part' style={{ alignItems: 'flex-start', gap: '20px' }}>
          <span>Depth of search, days</span>

          <div className="underline">
            <span className="slider-min">0</span>
            <input
              type="range"
              min="0"
              max="365"
              value={depth}
              onChange={handleInputChange}
              style={{
                "--range-progress": `${(depth / 365) * 100}%`,
              }}
            />
            <span className="slider-max">365</span>
          </div>

        </div>
        <hr />
        {/* Checkboxes */}
        <div className="checkbox-container">

          <div className='released-part' style={{ gap: '30px' }}>
            <label>
              Free
              <input
                type="checkbox"
                checked={types.free}
                onChange={() => handleTypesChange("free")}
                className="styled-checkbox"
              />

            </label>
            <label>
              Grossing
              <input
                type="checkbox"
                checked={types.grossing}
                onChange={() => handleTypesChange("grossing")}
                className="styled-checkbox"
              />

            </label>

          </div>

          {/* Update Button */}
          <div className="top-date">
            <button className='update-btn' onClick={(handleUpdate)} disabled={isLoading} style={{ opacity: isLoading ? '0.3' : '1' }}>Update</button>
            <button className='update-btn' onClick={() => setIsDialogOpen(true)} disabled={isLoading} style={{ opacity: isLoading ? '0.3' : '1', backgroundColor: '#5e5f5e', fontSize: '16px' }}>Save</button>
          </div>
        </div>
      </div>

      <DataTable data={response} isLoading={isLoading} />

      <div className="up-button">
        {pages && (
          <button className="scroll-top-button" onClick={goUp}>
            <svg className="arrow-icon" viewBox="0 0 24 24">
              <path d="M12 19V5M5 12l7-7 7 7" />
            </svg>
          </button>
        )}

      </div>

      {isDialogOpen && (
        <div className="overlay">
          <div className="dialog" ref={dialogRef}>
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Save filter settings</span>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter title"
              className="input"
            />
            <button
              className="cancel-button"
              onClick={() => {
                setIsDialogOpen(false);
                setTitle('')
              }} // Close the dialog
            >
              <MdOutlineClose size={20} style={{ opacity: '0.9', color: 'white' }} />
            </button>
            <div className="button-container">

              <button
                onClick={handleSave}
                className="button"
                disabled={isSaving}
              >
                {saveButtonText === 'Saving...' ? (
                  <span style={{ color: 'white', fontSize: '16px', lineHeight: '1' }}>
                    Saving
                    <span className="saving-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </span>
                ) : (
                  <span style={{ color: saveButtonText === "Save" ? 'white' : saveButtonText === "Saved!" ? 'white' : 'red', fontSize: '16px', lineHeight: '1', opacity: '0.9' }}>{saveButtonText}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      <footer className="footer">
        {pages && (
          <>
            {page > 1 ? (
              <button className="footer-button" onClick={onPrevious} disabled={isLoading}>
                <span className="bold" style={{ opacity: isLoading ? '0.3' : '1' }}>Previous</span>
              </button>
            ) : (
              <button className="footer-button" >
                <span className="bold" style={{ opacity: '0.3' }}>Previous</span>
              </button>
            )}
            <div className="footer-pagination" style={{ opacity: isLoading ? '0.3' : '1' }}>
              <span className="bold">Page</span>
              <input
                type="text"
                inputMode="numeric"
                value={tempValue}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^\d+$/.test(value)) {
                    setTempValue(value === '' ? '' : parseInt(value, 10)); // Convert to number
                  }
                }}
                onFocus={(e) => e.target.select()}
                onBlur={() => {
                  setTempValue(page);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const value = Number(tempValue);
                    if (!value || value < 1 || value > pages) {
                      setTempValue(page);
                    } else {
                      handleBlurOrEnter();
                    }
                    e.target.blur();
                  }
                }}
                className="page-number-input"
              />
              <span className="bold">of</span>
              <span className="bold">{pages}</span>
            </div>
            {page < pages ? (
              <button className="footer-button" onClick={onNext} disabled={isLoading}>
                <span className="bold" style={{ opacity: isLoading ? '0.3' : '1', marginRight: '20px' }}>Next</span>
              </button>
            ) : (
              <button className="footer-button" >
                <span className="bold" style={{ opacity: '0.3', marginRight: '20px' }}>Next</span>
              </button>
            )}
          </>
        )}
      </footer>
    </div>


  );
};

export default App;